import * as actions from './actions';

export const initialState = {
  initialized: false,
  modalShowing: false,
  modalContent: null,
  onInitializeSystem: {
    asyncStatus: '',
    message: '',
    status: 0
  },
  toastShowing: false,
  toastMessage: ''
};

export default (state = initialState, action) => {
  if (action.type === actions.types.ON_CHANGE_SYSTEM_MODAL) {
    return Object.assign({}, state, {
      modalContent: action.data
    });
  } else if (action.type === actions.types.ON_DISPLAY_SYSTEM_MODAL) {
    return Object.assign({}, state, {
      modalShowing: action.data
    });
  } else if (action.type === actions.types.ON_CHANGE_SYSTEM_TOAST) {
    return Object.assign({}, state, {
      toastMessage: action.data
    });
  } else if (action.type === actions.types.ON_DISPLAY_SYSTEM_TOAST) {
    return Object.assign({}, state, {
      toastShowing: action.data
    });
  } else if (action.type === actions.types.ON_INITIALIZE_SYSTEM_FULFILLED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      initialized: true,
      onInitializeSystem: { asyncStatus: 'FULFILLED', message, status }
    });
  } else if (action.type === actions.types.ON_INITIALIZE_SYSTEM_PENDING) {
    return Object.assign({}, state, {
      onInitializeSystem: { asyncStatus: 'PENDING', message: '', status: 0 }
    });
  } else if (action.type === actions.types.ON_INITIALIZE_SYSTEM_REJECTED) {
    const { message, status } = action.data;

    return Object.assign({}, state, {
      initialized: false,
      onInitializeSystem: { asyncStatus: 'REJECTED', message, status }
    });
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/qoc-redux/System/reducer.js